import Reflux from 'reflux';

const ReportLicenseActions = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

export default ReportLicenseActions;
